<template>
  <div>
    <van-tabs v-model="activeTabIndex" sticky>
      <van-tab title="未体检">
        <order-list-component :orders="appointedOrders" @onDataChanged="getOrders" />
      </van-tab>
      <van-tab title="已完成">
        <order-list-component :orders="finishOrders" @onDataChanged="getOrders" />
      </van-tab>
      <van-tab title="已取消">
        <order-list-component :orders="canceledOrders" @onDataChanged="getOrders" />
      </van-tab>
      <van-tab title="所有订单">
        <order-list-component :orders="userOrders" @onDataChanged="getOrders" />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
  import * as user_api from '@/api/user'
  import * as order_api from '@/api/order'
  import orderListComponent from './components/orderListComponent'
  import {
    mapState,
    mapMutations,
    mapActions
  } from "vuex";
  export default {
    components: {
      orderListComponent
    },
    data() {
      return {
        activeTabIndex: 0,
        userAccount: {},
        userOrders: [],
        appointedOrders: [],
        canceledOrders: [],
        finishOrders: []
      };
    },
    mounted() {
      this.userAccount = user_api.getLoginedUser();
      if (!this.userAccount) {
        this.$router.push('/');
        return
      }
      this.getOrders();
    },
    computed: {
      ...mapState({
        hospInfo: state => state.hospital.hospInfo
      })
    },
    methods: {
      getOrders() {
        order_api.getUserOrders(this.hospInfo.id, this.userAccount.id).then(res => {
          this.userOrders = res;
          this.appointedOrders = this.userOrders.filter(it => {
            return it.appointStatus == 1
          });
          this.canceledOrders = this.userOrders.filter(it => {
            return it.appointStatus == 9
          });
          this.finishOrders = this.userOrders.filter(it => {
            it.appointStatus == 2
          });
        });
      },
    }
  };
</script>